<div class="add-test-container">
    <div class="card-body">
        <div class="card-title">
            <h2>Uploading Approval</h2>
            <div class="divider"></div>
        </div>
        <div>
            <div class="row justify-content-between">
                <div class="col-md-4">
                    <label class="form-control-label required" for="approval">
                        Approval Type
                    </label>
                    <select class="form-control" id="approvalTypeId" [(ngModel)]="approvalTypeId">
                        <option [ngValue]="null" [disabled]="true">Select Approval Type</option>
                        <option *ngFor="let approval of approvalsTypes" [ngValue]="approval.id">
                            {{ approval.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label class="form-control-label required" for="file">
                        File
                    </label>
                    <input [(ngModel)]="fileToUpload" class="form-control" id="file" type="file" name="approval-file"
                        lang="en" accept=".doc,.docx,.pdf,image/*" (change)="onFileSelected($event.target.files)" />
                </div>
                <div class="form-actions col-md-2">
                    <button class="btn next-btn" (click)="upload()" [disabled]="isFormValid()">
                        Upload
                    </button>
                </div>

            </div>
        </div>
    </div>
    <br>

    <br>
    <div class="card-body">
        <div class="card-title">
            <h2>Patient's Approvals History</h2>
            <div class="divider"></div>
        </div>
        <ngx-datatable class="material ngx-datatable-custom" [rows]="patientApprovalsDetails" [columns]="columns"
            [limit]="pageSize" [offset]="currentPage-1" columnMode="force" externalPaging="true" [count]="totalItems"
            [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
            [messages]="messages">
            <ng-template let-row="row" #downloadRef ngx-datatable-row-detail-template>
                <span>
                    <button class="btn btn-icon btn-secondary" type="button" (click)="downloadApprovalFile(row)">
                        <span class="btn-inner--icon">
                            <i class="ni ni-cloud-download-95"> </i>
                        </span>
                        <span class="btn-inner--text"> Download </span>
                    </button>
                </span>
            </ng-template>
        </ngx-datatable>
    </div>